


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { getEntityRoute } from '@/helpers/entityType';
import { formatDate } from '@/helpers/dateTimeHelper';

@Component({
  name: 'ItinerariesPageItem',
})
export default class ItinerariesPageItem extends Vue {
  @Prop() item!: any;

  get backgroundImage() {
    return this.item.media?.url ? `url(${this.item.media.url})` : 'none';
  }

  get routeTo() {
    return getEntityRoute(this.item);
  }

  get startDate() {
    return formatDate(this.item.startDate);
  }

  get endDate() {
    return formatDate(this.item.endDate);
  }
}
